/* 🤖 this file was generated by svg-to-ts */
export const mgcIconChartBar2Filled: {
  name: 'chart-bar-2-filled';
  data: string;
} = {
  name: 'chart-bar-2-filled',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M15.58 3.047c-.733.14-1.4.821-1.537 1.57-.026.145-.043.854-.043 1.81V8h-2.073c-1.316 0-2.159.016-2.31.043-.768.141-1.433.806-1.574 1.574-.024.133-.043.713-.043 1.31V12H5.927c-1.316 0-2.159.016-2.31.043-.768.141-1.433.806-1.574 1.574-.059.326-.059 5.44 0 5.766.141.768.806 1.433 1.574 1.574.334.061 16.432.061 16.766 0 .768-.141 1.433-.806 1.574-1.574.061-.334.061-14.432 0-14.766-.141-.768-.806-1.433-1.574-1.574-.298-.054-4.515-.051-4.803.004"/></svg>`
};
